import { IGif } from '@giphy/js-types'
import { GifPermissions } from 'shared/types/user-permissions'
import { GET } from 'shared/util/fetch-methods'
import { getResults } from '.'

type Result = {}
type GifDetailResult = {
  permissions: GifPermissions
  gif: IGif
  has_permissions: boolean
  has_giphy_backdrop_maker?: boolean
}
let requestMap: { [key: string]: Promise<Result> } = {}

function request<T>(url: string) {
  if (!requestMap[url]) {
    requestMap[url] = getResults(url, GET)
  }
  return requestMap[url] as Promise<T>
}

export function getGifDetailPermissions(gifId) {
  return request<GifDetailResult>(`/ajax/gif/${gifId}/detail`)
}
